let store = null

function setStoreFromWindow() {
    store = {
        auth: null,
        isAuthenticate: false
    }

    if (!window.Auth) {
        return
    }

    store.isAuthenticate = true

    /** @type {id: int, name: string, email: string, lang: string|null, timezone: string|null, chat_transfer_count: int, chat_status: string} */
    store.auth = {
        ...window.Auth.user,

        /** @type {Array<{token: int, token_type: string}>} */
        notificationTokens: window.Auth.notification_tokens.map(i => ({
            token: i.token,
            token_type: i.token_type
        })),

        /** @type {service_chat_can_answer: boolean} */
        permissions: {
            ...window.Auth.permissions
        }
    }

    store.logo_dark = window.Auth.logo_dark

    store.auth.lang = store.auth.lang.replace('_', '-')

    /** @type string */
    store.authType = window.Auth.type

    store.prefixUrl = 'panel-' + store.authType

    delete window.Auth

    Object.freeze(store)

    document.getElementById('script-window-auth').remove()
}

setStoreFromWindow()

export default function() {
    return store
}
